export default {
  switchAccount: "Đổi tài khoản",
  login: "Đăng nhập",
  loginFirst: "Vui lòng đăng nhập tài khoản trước",
  start: "Bắt đầu Đố Vui",
  hasHistory: "Trước đây bạn đã trả lời một số câu hỏi,",
  loadHistory: "muốn tiếp tục không?",
  cancel: "Hủy",
  confirm: "Đồng ý",
  contact: "Điền vào thông tin liên hệ để có cơ hội nhận thưởng thêm!",
  completed: "Chúc mừng hoàn thành phiếu khảo sát",
  leaveMessage: "Lưu lại thông tin liên hệ để có cơ hội rút thưởng",
  enterEmail: "Hãy điền vào địa chỉ email của bạn:",
  enterPhone: "Hãy điền vào số điện thoại của bạn:",
  submit: "Gửi",
  leave: "Điền tạm, rời phiếu khảo sát",
  submitted: "Đã gửi,",
  thanks: "Cảm ơn bạn đã tin tưởng và ủng hộ",
  opinion: "Vui lòng chia sẻ quan điểm của bạn",
  prev: "Câu hỏi trước",
  next: "Câu hỏi tiếp theo",
  unlikely: "Không thể nào",
  likely: "Rất có thể",
  claimYourRewards: "Đây là phần thưởng dành cho bạn",
  rewardSent: "Đã phát thưởng",
  checkInGame: "Vui lòng vào game để xem",
  copy: "Sao chép",
  copied: "Sao chép thành công",
  selectTips: "Hãy chọn tùy chọn",
  multipleTips: "Đây là câu hỏi trắc nghiệm, vui lòng chọn nhiều tùy chọn",
  leastChoose: "Tối đa chọn xxx mục",
  maxChoose: "Tối thiểu chọn xxx mục",
  mustAnswer: "Hãy trả lời câu này",
  mustWrite: "Hãy điền nội dung vào",
  checkEmail: "Hãy điền vào địa chỉ email đúng định dạng",
  checkPhone: "Hãy điền vào số điện thoại đúng định dạng",
  isAnswer: "Bạn đã trả lợi câu hỏi",
  unStart: "Hoạt động chưa mở",
  end: "Hoạt động đã kết thúc",
  server: "Vui lòng chọn máy chủ",
  role: "Vui lòng chọn nhân vật",
  common: "Hệ thống bận, vui lòng thử lại sau",
  title: "Phiếu khảo sát",
  titleAward: "Làm khảo sát nhận thưởng",
  leastWord: "Nội dung bạn nhập ít hơn số từ tối thiểu xxx",
  maxWord: "Nội dung bạn nhập đã vượt quá số từ tối đa xxx",
  singleChoose: "Chọn Một",
  multiChoose: "Chọn Nhiều",
  matrix: "Câu Khuôn Mẫu",
  score: "Câu Đánh Giá",
  textLimit: "(xx-yy từ)",
  coverGiftTitle: "Điền khảo sát nhận quà",
  "-20001": "Chưa đăng nhập",
  "-20002": "Thiếu tham số bắt buộc",
  "-20003": "Không tìm thấy phiếu khảo sát",
  "-20004": "Đang cấu hình phiếu khảo sát",
  "-20005": "Phiếu khảo sát đã dừng",
  "-20006": "Sự kiện phiếu khảo sát chưa bắt đầu",
  "-20007": "Sự kiện phiếu khảo sát đã kết thúc",
  "-20008": "Đã trả lời",
  "-20010": "Phát thưởng thất bại",
  "-20011": "Phiếu khảo sát này đã phát thưởng",
  "-20012": "Chưa trả lời",
  "-20016": "ID game không hợp lệ",
};
